import React from "react"
import './Pages.css';

export default function Cardapio(){

    return (
    <section className="titulo">
      <h2>Cardápio</h2>
      <div className="subtitulo">
        <p>Os salgados mais saborosos para festa infantil, com qualidade e muito sabor em cada detalhe.</p>
      </div>
      <div className="img-container">
        <img loading="lazy" src="/images-webp/CardápioBuffet/cardapio.webp" alt="dadinho" />
        <img loading="lazy" src="/images-webp/CardápioBuffet/cardapio2.webp" alt="dadinho" />
        <img loading="lazy" src="/images-webp/CardápioBuffet/cardapio3.webp" alt="dadinho" />
        <img loading="lazy" src="/images-webp/CardápioBuffet/cardapio5.webp" alt="dadinho" />
        <img loading="lazy" src="/images-webp/CardápioBuffet/cardapio6.webp" alt="dadinho" />
        <img loading="lazy" src="/images-webp/CardápioBuffet/cardapio16.webp" alt="dadinho" />
        <img loading="lazy" src="/images-webp/CardápioBuffet/cardapio17.webp" alt="dadinho" />
        <img loading="lazy" src="/images-webp/CardápioBuffet/cardapio24.webp" alt="dadinho" />
        <img loading="lazy" src="/images-webp/CardápioBuffet/cardapio18.webp" alt="dadinho" />
        <img loading="lazy" src="/images-webp/CardápioBuffet/cardapio21.webp" alt="dadinho" />
        <img loading="lazy" src="/images-webp/CardápioBuffet/cardapio27.webp" alt="dadinho" />
        <img loading="lazy" src="/images-webp/CardápioBuffet/cardapio25.webp" alt="dadinho" />
        <img loading="lazy" src="/images-webp/CardápioBuffet/cardapio26.webp" alt="dadinho" />
        <img loading="lazy" src="/images-webp/CardápioBuffet/cardapio4.webp" alt="dadinho" />
        <img loading="lazy" src="/images-webp/CardápioBuffet/cardapio7.webp" alt="dadinho" />
        <img loading="lazy" src="/images-webp/CardápioBuffet/cardapio8.webp" alt="dadinho" />
        <img loading="lazy" src="/images-webp/CardápioBuffet/cardapio9.webp" alt="dadinho" />
        <img loading="lazy" src="/images-webp/CardápioBuffet/cardapio22.webp" alt="dadinho" />
        <img loading="lazy" src="/images-webp/CardápioBuffet/cardapio10.webp" alt="dadinho" />
        <img loading="lazy" src="/images-webp/CardápioBuffet/cardapio11.webp" alt="dadinho" />
        <img loading="lazy" src="/images-webp/CardápioBuffet/cardapio12.webp" alt="dadinho" />
        <img loading="lazy" src="/images-webp/CardápioBuffet/cardapio13.webp" alt="dadinho" />
        <img loading="lazy" src="/images-webp/CardápioBuffet/cardapio23.webp" alt="dadinho" />
        <img loading="lazy" src="/images-webp/CardápioBuffet/cardapio14.webp" alt="dadinho" />
        <img loading="lazy" src="/images-webp/CardápioBuffet/cardapio19.webp" alt="dadinho" />
        <img loading="lazy" src="/images-webp/CardápioBuffet/cardapio20.webp" alt="dadinho" />
      </div>
    </section>
  );
};